import axios from 'axios';
import { removeCookie, setEncryptedCookie } from '../../utils';
import authApi from '../auth';

export const axiosInstance = axios.create({
    headers: {
        'Content-Type': 'application/json'
    },
    withCredentials: true
});

export const setupAxiosInterceptors = (navigate, setTokenExpired) => {
    let isTokenExpired = false;

    axiosInstance.interceptors.response.use(
        (response) => {
            isTokenExpired = false;
            return response;
        },
        (error) => {
            if (error.response?.status === 401) {
                const onSuccess = () => {
                    removeCookie('abc');
                    removeCookie('at');
                    removeCookie('bi');
                    removeCookie('print');
                    removeCookie('buslap');
                    removeCookie('ci');
                    removeCookie('created_by');
                    removeCookie('def');
                    removeCookie('fdf');
                    removeCookie('id');
                    // removeCookie("name");
                    removeCookie('rt');
                    removeCookie('bas');
                    removeCookie('bass');
                    removeCookie('shop_id');
                    removeCookie('token');
                    removeCookie('uuid');
                    removeCookie('action');
                    removeCookie('proid');
                    removeCookie('bss');
                    removeCookie('upgrade');
                    removeCookie('upid');
                    removeCookie('ssoid');
                    removeCookie('ssoUid');
                    navigate('/');
                };
                const onFailure = () => {};
                authApi.logoutUser().then(onSuccess, onFailure);
                isTokenExpired = true;
                setTokenExpired(true);
            }
            return Promise.reject(error);
        }
    );
};
